/** PDF.js 6 loads OpenJPEG (JPEG2000) from wasmUrl; without it CONASET pages fail to decode. */
export const PDFJS_DOCUMENT_OPTIONS = {
  wasmUrl: '/pdfjs/wasm/',
  cMapUrl: '/pdfjs/cmaps/',
  cMapPacked: true,
  standardFontDataUrl: '/pdfjs/standard_fonts/',
  iccUrl: '/pdfjs/iccs/',
} as const;
